import api from "../../api";

export const getPropertiesAdvertisement = async () => {
    return await api.get("/property-zap-advertisement")
  };
